if (!customElements.get('swiper-carousel')) {
  customElements.define(
    'swiper-carousel',
    class SwiperCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
        this.loadAttempts = 0;
        this.handleResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        if (typeof Swiper === "undefined") {
          if (this.loadAttempts < 20) {
            this.loadAttempts += 1;
            setTimeout(() => this.connectedCallback(), 100);
          }

          return;
        }

        this.swiperEl = this.querySelector('.swiper');
        this.wrapper = this.querySelector('.swiper-wrapper');
        this.slides = this.querySelectorAll('.swiper-slide');

        this.prevEl = this.querySelector('.swiper-button-prev');
        this.nextEl = this.querySelector('.swiper-button-next');
        this.pagination = this.querySelector('.swiper-pagination');

        if (!this.swiperEl || !this.wrapper || !this.slides.length) return;

        this.settings = {
          desktopColumn: parseInt(this.dataset.desktopColumn || 1),
          mobileColumn: parseInt(this.dataset.mobileColumn || 1),
          autoplay: this.dataset.autoplay === "true",
          showArrow: this.dataset.showArrow === "true",
          showDots: this.dataset.showDots === "true",
          enableDesktop: this.dataset.enableDesktop !== "false",
          enableMobile: this.dataset.enableMobile !== "false",
          interval: parseInt(this.dataset.interval || 4000),
          gap: parseInt(this.dataset.gap || 16)
        };

        this.handleResize();
        window.addEventListener('resize', this.handleResize);
      }

      getGap(columns) {
        return columns > 1 ? this.settings.gap : 0;
      }

      shouldEnableSlider() {
        const isDesktop = window.innerWidth >= 769;
        return isDesktop ? this.settings.enableDesktop : this.settings.enableMobile;
      }

      enableStaticMode() {
        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
          this.sliderInstance = null;
        }

        this.classList.add('is-disabled');
      }

      initSlider() {
        if (this.sliderInstance) return;
        this.classList.remove('is-disabled');

        this.sliderInstance = new Swiper(this.swiperEl, {
          slidesPerView: this.settings.mobileColumn,
          spaceBetween: this.getGap(this.settings.mobileColumn),
          watchOverflow: true,
          threshold: 2,

          breakpoints: {
            769: {
              slidesPerView: this.settings.desktopColumn,
              spaceBetween: this.getGap(this.settings.desktopColumn)
            }
          },

          navigation:
            this.settings.showArrow && this.prevEl && this.nextEl
              ? { prevEl: this.prevEl, nextEl: this.nextEl }
              : false,

          pagination:
            this.settings.showDots && this.pagination
              ? { el: this.pagination, clickable: true }
              : false,

          autoplay: this.settings.autoplay
            ? {
                delay: this.settings.interval,
                disableOnInteraction: false
              }
            : false
        });
      }

      handleResize() {
        if (!this.shouldEnableSlider()) {
          this.enableStaticMode();
          return;
        }

        this.initSlider();
        this.sliderInstance?.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        if (this.sliderInstance) {
          this.sliderInstance.destroy(true, true);
          this.sliderInstance = null;
        }
      }
    }
  );
}
